import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.8_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_react-d_655531feb6f0bac0c439dd38a5e5664d/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.8_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_react-d_655531feb6f0bac0c439dd38a5e5664d/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CTAButtons"] */ "/vercel/path0/src/app/(frontend)/components/CTA/CTAButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedSection"] */ "/vercel/path0/src/app/(frontend)/components/HomePageAnimations/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackVisaPageView"] */ "/vercel/path0/src/app/(frontend)/components/PageViewTrackers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RefreshRouteOnSave"] */ "/vercel/path0/src/app/(frontend)/components/RefreshRouteOnSave/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceListCarousel"] */ "/vercel/path0/src/app/(frontend)/components/ResourceList/ResourceListCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsClient"] */ "/vercel/path0/src/app/(frontend)/components/Testimonials/TestimonialsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideosCarousel"] */ "/vercel/path0/src/app/(frontend)/components/Videos/VideosCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisaFAQ"] */ "/vercel/path0/src/app/(frontend)/components/VisaFAQ/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisaOverview"] */ "/vercel/path0/src/app/(frontend)/components/VisaOverview/index.tsx");
